<template>
  <vs-dropdown vs-trigger-click class="ml-auto cursor-pointer">
    <span class="name-text">{{ user.name }}</span>
    <vs-button radius icon="icon-user" icon-pack="feather" class="float-right" />

    <vs-dropdown-menu class="w-32">
      <vs-dropdown-item>
        <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
          <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
          <span>Profile</span>
        </div>
      </vs-dropdown-item>
      <vs-dropdown-item>
        <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
          <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
          <span>Tasks</span>
        </div>
      </vs-dropdown-item>
      <vs-dropdown-item>
        <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
          <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
          <span>Inbox</span>
        </div>
      </vs-dropdown-item>
      <vs-dropdown-item>
        <div @click="logout" class="flex items-center">
          <feather-icon icon="LogOutIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
          <span>Logout</span>
        </div>
      </vs-dropdown-item>
    </vs-dropdown-menu>

  </vs-dropdown>
</template>

<script>
  export default {
    name: "root-profile-dropdown",
    data: ()=> ({
      user: {},
    }),
    created(){
      this.user = this.$store.state.activeUser;
    },
    methods: {
      logout() {
        this.$store.dispatch('clearUserInfo').then(() => {
          // this.$router.push('/pages/login').catch(() => {});
          location.reload();
        }).catch(() => {});
      }
    }
    // mounted() {
    //   // subscribe to changes on the state
    //   this.$store.subscribe((mutation, state) => {
    //     if (mutation.type === 'setNextPayment') {
    //       // console.log(`Updating setNextPayment - ${state}`);
    //       this.next_payment_info = state.nextPayment
    //     }
    //   });
    // },
  }
</script>

<style scoped>
  .name-text {
    font-size: 18pt;
    padding-right: 0.5em;
  }
</style>
